import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { collection } from '@/services/collection';
import { scrollToElement } from '@/utils/scroll';

@Component
export class CollectionMain extends ThemeComponent {
    @Ref() loading!: HTMLElement;

    init() {

        // Listen for pagination clicks
        this.listenForPaginationClicks();

        // Subscribe to collection state changes
        this.$subscribe(collection.onChange, () => this.reload());
    }

    listenForPaginationClicks() {
        const previous = this.querySelector('.pagination .next a') as HTMLElement;
        const next = this.querySelector('.pagination .prev a') as HTMLElement;
        const pages = this.querySelectorAll('.pagination .page a');
        if (previous) {
            this.$listen(previous, 'click', (e) => this.handlePaginationClick(e));
        }
        if (next) {
            this.$listen(next, 'click', (e) => this.handlePaginationClick(e));
        }
        for (const page of pages) {
            const pageElement = page as HTMLElement;
            this.$listen(pageElement, 'click', (e) => this.handlePaginationClick(e));
        }
    }

    handlePaginationClick(e: Event) {

        // Prevent default
        e.preventDefault();

        // Get clicked element
        let clickedElement = e.target as HTMLElement;
        if (clickedElement.tagName !== 'A') {
            clickedElement = clickedElement.closest('a') as HTMLElement;
        }

        // Get href from clicked element
        const href = clickedElement.getAttribute('href');
        if (href) {

            // Define new state
            const state = collection.parseState(href);

            // Update view
            void collection.update(state);
        }
    }

    async reload() {

        // Set loading
        this.setLoading(true);

        // Make request for the next URL
        const response = await collection.render(['collection-main', 'collection-active-filters']);

        // Scroll to element
        scrollToElement(this);

        // Get new elements from response data and replace components
        this.outerHTML = response['collection-main'];
        const activeFilters = document.querySelector('.collection-active-filters');
        if (activeFilters) {
            activeFilters.outerHTML = response['collection-active-filters'];
        }

        // Update clear all URL
        const clearAllElement = document.querySelector('.collection-active-filters__clear');
        const mobileClearAllElement = document.querySelector('.product-filters__mobile-clear');
        if (clearAllElement == null) {
            mobileClearAllElement?.classList.add('product-filters__mobile-clear--hidden');
        } else {
            const clearHref = clearAllElement.getAttribute('href');
            if (clearHref) {
                mobileClearAllElement?.setAttribute('href', clearHref);
            }
            mobileClearAllElement?.classList.remove('product-filters__mobile-clear--hidden');
        }

        // Set loading
        this.setLoading(false);
    }

    public setLoading(loading: boolean = false) {
        if (loading) {
            this.loading.classList.add('loading-spinner--active');
        } else {
            this.loading.classList.remove('loading-spinner--active');
        }
    }
}
